<template>
  <div class="apparel" v-if="viewport">
    <banner :navIndex="1">
      <template slot="banner">
        <div class="banner">
          <div class="centre" :style="{'will-change': 'transform',transform: `translate3d(0,${transLateY}px,0)`}">
            <h1 class="title">Smart Wearables</h1>
            <div class="line"></div>
            <div class="text">
              <p>
                By combining multi-channel biosensors, big data in human physiology, and artificial intelligence, smart
                wearables can realize continuous monitoring for multi-modal bio-signals in a high-precision,
                long-term manner. This technology will allow our users to set up their personalized health models that
                can advise on status, risks, and actions. The model can also serve to assist healthcare professionals
                for screening, diagnosis, and interventions at early stages. Smart wearables can also be applied in
                practices of emergency medicine, critical care, and chronic disease management.
              </p>
            </div>
          </div>
        </div>
      </template>
    </banner>
    <div style="position: relative;z-index: 2;background-color: #fff;  min-width: 1600px;">
      <Slideshow ref="slideshow"></Slideshow>
      <platform></platform>
      <div class="footer-box">
        <relation></relation>
      </div>
    </div>
  </div>
  <div v-else class="phone-wrap">
    <div class="background">
      <div class="nav">
        <div class="logo">
          <img src="@/assets/phone/phone-logo.png">
        </div>
        <div @click="onList" class="fork">
          <span class="iconfont icon-liebiaoshitucaidan"></span>
        </div>
      </div>
      <div class="title">
        <h1>Smart Wearables</h1>
      </div>

      <div v-show="list" class="list">
        <phoneNav @onHide="onHide"></phoneNav>
      </div>
    </div>
    <div class="txt">
      <p>
        By combining multi-channel biosensors, big data in human physiology, and artificial intelligence, smart
        wearables can realize continuous monitoring for multi-modal bio-signals of in a high-precision, long-term
        manner. This technology will allow our users to set up their personalized health models that can advise on
        status, risks, and actions. The model can also serve to assist healthcare professionals for screening,
        diagnosis, and interventions at early stages. Smart wearables can also be applied in practices of emergency
        medicine, critical care, and chronic disease management.
      </p>
    </div>
    <div class="tab">
      <div class="roll">
        <div class="tab-nav">
          <div :class="{active : item === 1}" @click="onTab(1)">Unimodal&nbsp;wearables</div>
          <div :class="{active : item === 2}" @click="onTab(2)">Multimodal&nbsp;wearables</div>
          <div :class="{active : item === 3}" @click="onTab(3)">Wearables&nbsp;for&nbsp;specific&nbsp;medical&nbsp;needs</div>
        </div>
      </div>
      <div class="striping" ></div>
      <div class="detail">
        <div v-if="item === 1" class="unify basics">
          <div class="order">
            <img src="@/assets/phone/01.png">
          </div>
          <div class="introduce">
            <h3>Unimodal wearables</h3>
            <p>
              Long-term healthcare monitoring based on<br/> AI-empowered wearable ECG/PPG devices
            </p>
          </div>
          <div class="picture">
            <div class="group">
              <img src="@/assets/phone/Group791.png">
            </div>
            <div class="sling">
              <img src="@/assets/phone/sling.png">
            </div>
          </div>
          <div class="exercise">
            <div class="line-chart">
              <img src="@/assets/phone/Group792.png">
            </div>
            <div class="watches">
              <img src="@/assets/phone/slide_4.png">
            </div>
          </div>
        </div>
        <div v-if="item === 2" class="unify polybasic">
          <div class="order">
            <img src="@/assets/phone/02.png">
          </div>
          <div class="introduce">
            <h3>Multimodal wearables</h3>
            <p>
              Comprehensive physiology data collection and<br/> monitoring via diverse wearable sensing technologies
            </p>
          </div>
          <div class="picture">
            <img src="@/assets/phone/Group794.png">
          </div>
        </div>
        <div v-if="item === 3" class="unify special">
          <div class="order">
            <img src="@/assets/phone/03.png">
          </div>
          <div class="introduce">
            <h3>Wearables for specific medical needs</h3>
            <p>
              Facial monitoring for emotion estimation Human<br/> posture monitoring
            </p>
          </div>
          <div class="picture">
            <div class="person">
              <img src="@/assets/phone/Group795.png">
            </div>
            <div class="vertical">
              <div class="skeleton">
                <img src="@/assets/phone/Maskgroup10.png">
              </div>
              <div class="expression">
                <img src="@/assets/phone/Group796.png">
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="platform">
      <div class="title">
        <h2>Data platform for wearables</h2>
      </div>
      <div class="human-body">
        <div class="perception">
          <div class="signal">
            <img src="@/assets/phone/signalstrength.png">
          </div>
          <h4>Signal acquisition from wearables</h4>
        </div>
        <div class="pic">
          <img src="@/assets/phone/Maskgroup.png">
        </div>
      </div>
      <div class="information">
        <div class="communication">
          <div class="phone">
            <img src="@/assets/phone/iphone1.png">
          </div>
          <h5>Data communication</h5>
          <div class="wireless">
            <img src="@/assets/phone/wifi.png">
          </div>
        </div>
        <div class="text">
          <div>Data Transmission</div>
          <div>5G Communication</div>
        </div>
        <div class="icon">
          <div class="left-line"></div>
          <div class="iconfont">
            <img src="@/assets/phone/Vector.png">
          </div>
          <div class="right-line"></div>
        </div>
        <div class="task">Data task</div>
        <div class="exercise">
          <div>Health data</div>
          <div class="line">Sports data</div>
          <div>Status data</div>
        </div>
        <div class="arrows">
          <img src="@/assets/phone/Vector.png">
        </div>
      </div>
      <div class="information">
        <div class="communication top">
          <div class="phone">
            <img src="@/assets/phone/uploadone.png">
          </div>
          <h5>Data platform</h5>
          <div class="wireless">
            <img src="@/assets/phone/code-computer.png">
          </div>
        </div>
        <div class="text2">
          <div>Data Storage Platform</div>
          <div>Data Computing Platform</div>
        </div>
        <div class="icon">
          <div class="left-line"></div>
          <div class="iconfont">
            <img src="@/assets/phone/Vector.png">
          </div>
          <div class="right-line"></div>
        </div>
        <div class="task">Intelligent computing</div>
        <div class="calculate exercise">
          <div>Data Processing Platform</div>
          <div class="line">Model Training Platform</div>
          <div>AI Computing Platform</div>
        </div>
        <div class="arrows">
          <img src="@/assets/phone/Vector.png">
        </div>
        <div class="AIalgorithm">AI algorithm</div>
        <div class="algorithm exercise">
          <div>AI for chronic disease</div>
          <div class="line">AI for intensive care</div>
          <div>AI for<br /> motion</div>
        </div>
        <div class="arrows">
          <img src="@/assets/phone/Vector.png">
        </div>
        <div class="AIalgorithm">Healthcare output</div>
        <div class="manage exercise">
          <div>Early warning</div>
          <div class="line">Physical exam recommendation</div>
          <div>Diagnosis and treatment&nbsp;assist</div>
        </div>
      </div>
    </div>
    <phoneFooter></phoneFooter>
  </div>
</template>

<script>
import banner from '@/components/banner'
import Slideshow from './components/slideshow'
import platform from './components/platform'
import relation from '@/components/footer'
import phoneNav from '@/components/phoneNav/index'
import phoneFooter from "@/components/phoneFooter";


export default {
  name: "apparel.vue",

  components: {
    phoneNav,
    banner,
    Slideshow,
    platform,
    relation,
    phoneFooter,

  },
  data() {
    return {
      toTop: 0,
      transLateY: 0,
      scroll: false,
      viewport: true,
      screenWidth: null,
      list: false,
      item: 1,
    }
  },
  watch: {
    screenWidth: function (n, o) {
      if (n <= 1024) {
        this.viewport = false
      } else {
        this.viewport = true
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll) //监听页面滚动
    this.screenWidth = document.body.clientWidth
    if (document.documentElement.clientWidth < 1280) {
      this.viewport = false
    }
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }

  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {

    onList() {
      setTimeout(() => {
        this.list = true
      }, 200)

    },

    onHide() {
      setTimeout(() => {
        this.list = false
      }, 200)

    },


    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop,
          radio = window.screen.width <= 1600 ? 0.7 : 1
      if (scrollTop < (900 * radio)) {
        if (this.toTop <= scrollTop) {
          this.transLateY = scrollTop / 10
        } else {
          this.transLateY = -scrollTop / 10
        }
      }
      //判断鼠标方向
      this.scroll = this.toTop < scrollTop
      this.toTop = scrollTop
      if (scrollTop > (850 * radio) && scrollTop < (1800 * radio) && this.scroll) {
        this.$refs.slideshow.init(true)
      } else if (scrollTop < (910 * radio) && !this.scroll) {
        this.$refs.slideshow.init(true)
      } else {
        this.$refs.slideshow.init(false)
      }
    },

    onTab(index) {
      this.item = index

    }
  }
}
</script>

<style scoped>
.apparel {
  min-width: 1280px;
}


.banner .centre {
  width: 1200px;
  margin: 0 auto;
}

.centre .title {
  margin-top: 142px;
  color: #FFFFFF;
  font-weight: 700;
  font-size: 42px;
  line-height: 72px;
  letter-spacing: 1px;
}

.centre .line {
  margin-top: 42px;
  width: 60px;
  height: 6px;
  background-color: #FFFFFF;
}

.centre .text {
  padding-top: 60px;
}

.centre .text p {
  font-size: 24px;
  line-height: 50px;
  color: #FFFFFF;
}

.nav {
  display: flex;
  justify-content: space-between;
  padding: 1.14rem 0.6rem 0;
}

.nav .logo {
  display: flex;
  align-items: center;
  height: 0.43rem;
}

.nav .logo img {
  height: 0.35rem;
}

.nav .fork {
  color: #FFFFFF;
  line-height: 0.43rem;
  height: 0.43rem;
}

.nav .fork .iconfont {
  font-size: 0.36rem;
}

.list {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}

.background {
  background-image: url("../../assets/phone/apparel.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

.background .title {
  padding: 1.84rem 0 2.06rem 0.7rem;
}

.background .title h1 {
  font-weight: 700;
  font-size: 0.46rem;
  line-height: 0.61rem;
  color: #FFFFFF;
}

.phone-wrap .txt {
  padding: 0.8rem 0.6rem 0.6rem;
}

.phone-wrap .txt p {
  font-size: 0.24rem;
  line-height: 0.4rem;
  color: #111111
}


.tab .striping {
  height: 0.02rem;
  width: 100%;
  background: #D7D7D7;
}

.tab .roll {
  padding: 0 0.6rem;
  width: 100%;
  display: flex;
  overflow: hidden;
  overflow-x: scroll;
}

.tab .detail {
  padding: 0 0.6rem;
}

.tab .roll::-webkit-scrollbar {
  display: none;
}

.tab .tab-nav {
  width: 250%;
  overflow: visible;
  display: flex;
  justify-content: space-between;
}



.tab .tab-nav div {
  position: relative;
  margin-right: 0.3rem;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.72rem;
  color: #999999;
}


.tab .tab-nav div:nth-child(3) {
  margin-right: 0.6rem;
  /*width: 4.8rem;*/
}

.tab .tab-nav .active {
  color: #111111;
  font-weight: 700;
}

.tab .tab-nav .active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 1.13rem;
  height: 0.03rem;
  background: linear-gradient(270deg, #CD7482 0%, #A3DBEE 100%);



}

.tab .unify {
  padding-top: 1rem;
  padding-bottom: 1.6rem;
}

.tab .unify .order {
  position: relative;
}

.tab .unify .order img {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  height: 0.62rem;
}

.tab .unify .introduce {
  padding-top: 0.24rem;
}

.unify .introduce h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 0.33rem;
  line-height: 0.73rem;
  color: #111111;
}

.unify .introduce p {
  margin-top: 0.19rem;
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.52rem;
}

.basics .picture {
  display: flex;
  padding-top: 0.3rem;
}

.basics .picture .group {
  width: 3.6rem;
}

.basics .picture .group img {
  width: 3.6rem;
}

.basics .picture .sling img {
  width: 64%;
}

.basics .picture .sling {
  margin-top: 0.48rem;
  margin-left: 0.2rem;
  padding-top: 0.29rem;
  width: 2.5rem;
  height: 2.2rem;
  background: #F0F5F9;
  border-radius: 8px;
  text-align: center;
}

.basics .exercise {
  margin-top: 0.2rem;
  display: flex;
}

.basics .exercise .line-chart img {
  width: 3.6rem;
}

.basics .exercise .watches {
  margin-left: 0.2rem;
  padding-top: 0.11rem;
  width: 2.5rem;
  height: 1.8rem;
  background: #F0F5F9;
  border-radius: 0.08rem;
  text-align: center;
}

.basics .exercise .watches img {
  height: 1.6rem;
}

.polybasic .picture {
  margin-top: 0.3rem;
  height: 4.75rem;
}

.polybasic .picture img {
  width: 6.3rem;
}

.special .picture {
  display: flex;
  margin-top: 0.78rem;
}

.special .picture .person img {
  width: 3.25rem;
}

.special .picture .skeleton img {
  width: 2.85rem;
}

.special .picture .expression {
  margin-top: 0.12rem;
}

.special .picture .expression img {
  width: 2.85rem;
}

.special .picture .vertical {
  margin-left: 0.2rem;
}

.platform {
  padding-bottom: 1.3rem;
}

.platform .title {
  padding: 0.48rem 0 0.48rem 0.6rem;
  background: #F5F6F8;
}

.platform .title h2 {
  font-style: normal;
  font-weight: 700;
  font-size: 0.32rem;
  line-height: 0.4rem;
  color: #111111;
}

.platform .human-body {
  padding-top: 1rem;
}

.platform .human-body .perception {
  display: flex;
  justify-content: center;
}

.human-body .perception .signal {
  padding-top: 0.02rem;
}

.human-body .perception .signal img {
  height: 0.3rem;
}

.platform .human-body .perception h4 {
  margin-left: 0.17rem;
  font-style: normal;
  font-weight: 400;
  font-size: 0.28rem;
  line-height: 0.37rem;
}

.platform .human-body .pic {
  padding-bottom: 0.75rem;
  margin-top: 0.6rem;
  text-align: center;
}

.platform .human-body .pic img {
  width: 6.34rem;
}


.platform .communication {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
}

.platform .communication .phone {
  width: 1rem;
  height: 1rem;
  background: #2D2E33;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.platform .communication .phone img {
  width: 0.66rem;
}

.platform .communication h5 {
  font-style: normal;
  font-weight: 500;
  font-size: 0.28rem;
  line-height: 0.37rem;
  text-align: center;
  width: 2.14rem;
}

.platform .communication .wireless {
  width: 1rem;
  height: 1rem;
  background: #2D2E33;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.platform .communication .wireless img {
  width: 0.66rem;
}

.platform .top {
  margin-top: 0.82rem;
}

.information .text {
  margin-top: 0.2rem;
  display: flex;
  justify-content: space-between;
  padding-left: 0.96rem;
  padding-right: 0.74rem;
}


.information .text div {
  width: 2.53rem;
  font-style: normal;
  font-weight: 400;
  font-size: 0.24rem;
  line-height: 0.34rem;
  color: #111111;
  text-align: center;
}

.information .text2 {
  display: flex;
  justify-content: space-between;
  margin-top: 0.2rem;
  padding-left: 0.82rem;
  padding-right: 0.62rem;
  font-style: normal;
  font-weight: 400;
  font-size: 0.22rem;
  line-height: 0.29rem;
  color: #111111;
  text-align: center;
}


.information .icon {
  margin-top: 0.3rem;
  display: flex;
  justify-content: space-between;
  padding: 0 2rem;

}

.information .icon .left-line {
  width: 0.4rem;
  height: 0;
  border-top: 0.01rem dashed #7AABCC;
  transform: rotate(45deg);
}

.information .icon .right-line {
  width: 0.4rem;
  height: 0;
  border-top: 0.01rem dashed #7AABCC;
  transform: matrix(-0.71, 0.71, 0.71, 0.71, 0, 0);
}

.information .icon .iconfont {
  line-height: 0;
}

.information .icon .iconfont img {
  height: 0.24rem;
}

.information .task {
  margin-top: 0.82rem;
  font-style: normal;
  font-weight: 500;
  font-size: 0.28rem;
  line-height: 0.37rem;
  text-align: center;
}

.information .AIalgorithm {
  margin-top: 0.52rem;
  font-style: normal;
  font-weight: 500;
  font-size: 0.28rem;
  line-height: 0.39rem;
  text-align: center;
}

.information .exercise {
  margin-top: 0.4rem;
  padding: 0 1.4rem;
  display: flex;
  justify-content: space-between;
}

.information .exercise div {
  width: 2rem;
  font-style: normal;
  font-weight: 400;
  font-size: 0.22rem;
  line-height: 0.29rem;
  color: #111111;
  text-align: center;
}

.information .exercise .line {
  position: relative;
}

.information .exercise .line::after {
  content: '';
  position: absolute;
  right: 0rem;
  top: 50%;
  transform: translateY(-50%);
  height: 0.2rem;
  width: 0;
  border-left: 0.02rem dashed #7AABCC;
  opacity: 0.3;
}

.information .exercise .line::before {
  content: '';
  position: absolute;
  left: 0rem;
  transform: translateY(-50%);
  top: 50%;
  height: 0.2rem;
  width: 0;
  border-right: 0.02rem dashed #7AABCC;
  opacity: 0.3;
}

.information .arrows {
  margin-top: 0.52rem;
  text-align: center;
  line-height: 0;
}

.information .arrows img {
  height: 0.24rem;
}

.information .calculate {
  padding: 0.58rem;
  display: flex;
  justify-content: space-between;
}

.information .algorithm {
  padding: 0 0.62rem;
  display: flex;
  justify-content: space-between;
}

.information .manage {
  padding: 0 0.58rem 0 0.96rem;
}

.information .manage div:nth-child(1) {
  width: 1.3rem;
  margin-right: 0.42rem;
}

.information .manage div:nth-child(2) {
  width: 2.06rem;
}

.information .manage div:nth-child(3) {
  margin-left: 0.14rem;
}

</style>
